import { ModelBase } from 'store/model-base';

export class CmsDeviceUpgrade extends ModelBase {
    public static storeName: string = 'cmsDeviceUpgrade';

    public header: string;
    public upgradeDeviceIcon: CmsMediaImage;
    public switchDeviceIcon: CmsMediaImage;
    public omniChannelUpgradeDevice: CmsUpgradeDevice;
    public fccSimSwapUpgradeDevice: CmsUpgradeDevice;
    public upgradeDevice: CmsUpgradeDevice;
    public switchDevice: CmsSwitchDeviceCollection;
    public fccSimSwapSwitchDevice: CmsSwitchDeviceCollection;
    public extendedPromoDetail: CmsExtendedPromoDetail;
    public shopNowButton: string;
    public makePaymentButton: string;
    public findStoreLink: string;
}
